import React, { useMemo } from 'react';

import { useTranslation } from '../../../i18n';

import { PayBlock } from './card';

import { PaymentMethodProps } from './payment-method.types';
import { PayPrice, PayPriceCommission } from './styled';

import { StripeCard } from './stripe/stripe-card';

import { currencyToSign } from '../../../helpers/currency';
import { getStripeCommission } from '../../../helpers/commission';
import { simpleSum } from '../../../helpers/numbers';

export const PayWithStripe: React.FC<PaymentMethodProps> = ({ price, currency, orderID, onPay, onError }) => {
  const [t] = useTranslation('rates');

  const sign = currencyToSign(currency);
  const commission = getStripeCommission(Number(price));

  const fullPrice = useMemo(() => Math.floor(simpleSum([price, commission]) * 100), [commission, price]);

  return (
    <PayBlock className="is-hover-shadow">
      <PayPrice>
        {price} {sign}
      </PayPrice>
      <PayPriceCommission>
        (+{t('rates.payments.commission')} {commission} {sign})
      </PayPriceCommission>

      <StripeCard
        amount={fullPrice}
        currency={currency}
        label={`Pay for the "${orderID}"`}
        onPay={onPay}
        onError={onError}
      />
    </PayBlock>
  );
};
